import ApiService from "@/common/api.service";

const PATH = "stock/sales-orders";

export const GET_STOCK_SALES_ORDERS = "getStockSalesOrders";
export const GET_STOCK_SALES_ORDER = "getStockSalesOrder";
export const CREATE_STOCK_SALES_ORDER = "createStockSalesOrder";
export const UPDATE_STOCK_SALES_ORDER = "updateStockSalesOrder";
export const CONFIRM_STOCK_SALES_ORDER = "confirmStockSalesOrder";
export const CANCEL_STOCK_SALES_ORDER = "cancelStockSalesOrder";
export const CREATE_DELIVERY_FROM_SO = "createDeliveryFromSalesOrder";
export const CREATE_PO_FROM_SO = "createPurchaseOrderFromSalesOrder";
export const GET_STOCK_PO_DRAFT_FROM_SO = "getStockPurchaseOrderDraftFromSalesOrder";
export const GET_STOCK_SO_MOVEMENTS = "getStockSalesOrderMovements";
export const UPLOAD_STOCK_SO_FILES = "uploadStockSalesOrderFiles";
export const DELETE_STOCK_SO_FILE = "deleteStockSalesOrderFile";
export const DOWNLOAD_STOCK_SO_FILE = "downloadStockSalesOrderFile";
export const REGENERATE_STOCK_SO_DOCUMENT = "regenerateStockSalesOrderDocument";
export const CREATE_TRANSPORT_ORDER_FROM_SO = "createTransportOrderFromSalesOrder";
export const GET_STOCK_SO_COUNTERPARTY_PO_OPTIONS = "getStockSalesOrderCounterpartyPurchaseOrderOptions";
export const GET_STOCK_SO_TRANSPORT_CANDIDATES = "getStockSalesOrderTransportCandidates";

const actions = {
  [GET_STOCK_SO_COUNTERPARTY_PO_OPTIONS](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${PATH}/counterparty-purchase-order-options`, params || {})
        .then(({ data }) => resolve(data.data || []))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_SALES_ORDERS](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(PATH, {
        ...(params || {}),
        ...context.rootGetters.stockContextFilterParams,
      })
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_SALES_ORDER](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get(PATH, id)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CREATE_STOCK_SALES_ORDER](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post(PATH, params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [UPDATE_STOCK_SALES_ORDER](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.update(PATH, payload.id, payload.params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CONFIRM_STOCK_SALES_ORDER](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/confirm`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CANCEL_STOCK_SALES_ORDER](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/cancel`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CREATE_DELIVERY_FROM_SO](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${payload.id}/create-delivery`, payload.params || {})
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CREATE_PO_FROM_SO](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${payload.id}/create-purchase-order`, payload.params || {})
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_PO_DRAFT_FROM_SO](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${PATH}/${payload.id}/purchase-order-draft`, payload.params || {})
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_SO_MOVEMENTS](context, payload) {
    const salesOrderId = payload.salesOrderId || payload.id;

    return new Promise((resolve, reject) => {
      ApiService.query(`${PATH}/${salesOrderId}/movements`, {
        itemsPerPage: payload.itemsPerPage || 50,
        page: payload.page || 1,
      })
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [UPLOAD_STOCK_SO_FILES](context, payload) {
    const formData = new FormData();
    (payload.files || []).forEach((file) => formData.append("files[]", file));

    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${payload.id}/files`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [DELETE_STOCK_SO_FILE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.delete(`${PATH}/${payload.id}/files/${payload.fileId}`)
        .then(() => resolve(true))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [DOWNLOAD_STOCK_SO_FILE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.downloadFile(
        `${PATH}/${payload.id}/files/${payload.fileId}/download`,
        payload.originalName || payload.name || "download"
      )
        .then(() => resolve(true))
        .catch((error) => reject(error?.response?.data || error));
    });
  },

  [REGENERATE_STOCK_SO_DOCUMENT](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/regenerate-document`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_SO_TRANSPORT_CANDIDATES](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${PATH}/${id}/transport-candidates`)
        .then(({ data }) => resolve(Array.isArray(data.data) ? data.data : []))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CREATE_TRANSPORT_ORDER_FROM_SO](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/create-transport-order`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },
};

export default {
  state: {},
  getters: {},
  actions,
  mutations: {},
};
